import { Frame } from "../shared";
import type { WidgetProps } from "../types";

/** The `text` widget (config_text): plain text with its line breaks, no markup and no links. */
export function TextNote({ widget }: WidgetProps) {
  const text = typeof widget.config?.text === "string" ? widget.config.text : "";
  return (
    <Frame widget={widget} state={text ? "normal" : "empty"} title={widget.title}>
      <p className="min-h-0 overflow-auto text-sm whitespace-pre-line text-gray-900">{text}</p>
    </Frame>
  );
}
